import { useCallback, useEffect, useMemo, useState } from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { logger, urls } from "whole-shared";

import { config } from "../config";
import { ws } from "../ws";
import { Loading, NotFound } from "./Components";
import type { IContext } from "./context";
import { Context, defaultContext } from "./context";
import { DevMatch } from "./DevMatch";
import { Header, SITE_HEADER_HEIGHT_PX } from "./Header";
import { Match } from "./Match";
import { QueueSettings } from "./QueueSettings";
import { Settings } from "./Settings";

const GdprCookies = () => {
  const [gdprCookies, setGdprCookies] = useState(
    decodeURIComponent(document.cookie)
      .split(";")
      .some(_ => /\s*c=1/.exec(_))
  );

  return gdprCookies ? null : <div className="panel" style={{ alignItems: "center", bottom: 0, display: "flex", left: 0, position: "absolute" }}>
    <div style={{ paddingRight: ".5em" }}>
      {"This website uses cookies only for technical purposes."}
      <br />
      {"User data is stored and used only to operate the service."}
    </div>
    <button
      onClick={() => {
        document.cookie = `c=1; expires=${new Date(Date.now() + 31536000000).toUTCString()}; path=/`;
        setGdprCookies(true);
      }}
    >
      {"Got it"}
    </button>
  </div>;
};

const Home = () => <div>
  <Link to="/match">dev match</Link>
</div>;

export const Whole = () => {
  const [partialContext, setPartialContext] = useState<Omit<IContext, "updateContext">>(defaultContext);
  const updateContext = useCallback((update: Partial<Omit<IContext, "updateContext">>) => setPartialContext(prev => ({ ...prev, ...update })), []);
  const context = useMemo(() => ({ ...partialContext, updateContext }), [partialContext, updateContext]);

  const { inMatch, player, queueSettings, stage } = context;

  useEffect(() => {
    const handler = (e: ErrorEvent) => logger.error(e.error);

    window.addEventListener("error", handler);

    return () => window.removeEventListener("error", handler);
  }, []);

  useEffect(() => {
    config.on("config", config => {
      if(config.stage === "prod") logger.debug = () => {};

      logger.debug("config", config);
      updateContext(config);
    });

    ws.on("connection", connected => updateContext({ connected }));
  }, [updateContext]);

  if(player.isLogged() && ! player.displayName) history.pushState(null, "", "/settings");

  return stage === "unknown" ? <Loading /> : <Context.Provider value={context}>
    <BrowserRouter>
      <Header />
      <div style={{ marginTop: inMatch ? 0 : SITE_HEADER_HEIGHT_PX }}>
        <Routes>
          <Route caseSensitive path={urls.devMatch} element={<DevMatch />} />
          <Route caseSensitive path={urls.match} element={<Match />} />
          <Route caseSensitive path={urls.settings} element={<Settings />} />
          <Route index element={<Home />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </div>
      {queueSettings && <QueueSettings />}
      <GdprCookies />
    </BrowserRouter>
  </Context.Provider>;
};
